<script setup >
import gou from '@/assets/icons/svg/gou.svg'
import yinlian from '@/assets/images/yinlian.png'
import xieyi from '@/assets/images/xieyi.png'
import guitai from '@/assets/images/guitai.png'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useTaxStore } from '@/store/modules/tax.js'
import { computed } from 'vue';
import {usePersonTaxSummary} from "../consolidatedIncome/components/fourStatistCommon.js";
const taxStore = useTaxStore()
const { userAnswer } = storeToRefs(taxStore);
const tableRef = ref()
const tableData = ref([{}])

const {All_Answer_TaxCreditPayable} = usePersonTaxSummary(userAnswer.value)


const TaxCreditPayable = computed(()=>{
  return All_Answer_TaxCreditPayable.value
})

const payWay = ref('2')
//获取选中
const getSelectionRows = () =>{
    let rows = tableRef.value.getSelectionRows();
    console.log(rows)
    return rows
}
const dialogVisible = ref(false)
const beginPay = () =>{
    const rows = getSelectionRows()
    if(rows.length == 0){
        return ElMessage({
            message: '请先勾选缴款申请表',
            type: 'info',
            offset:300
        })
    }
    ElMessageBox.confirm(
    '是否确认要对勾选记录进行纳税？',
    '确认信息',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'info',
    }
  )
    .then(() => {
        dialogVisible.value = true;
    })
    .catch(() => {

    })
}
const payStep = ref(1)
const payOne = (key) =>{
    payStep.value = key
}
const currentPayImg = {
    '1':xieyi,
    '2':yinlian,
    '3':guitai
}
const init = () =>{
    payStep.value = 1;
    payWay.value = '2'
}
</script>

<template>
    <div class="pay_over">
        <div class="tip">
            <el-icon color="#409eff"><WarningFilled /></el-icon>
            提示：如果您进行了立即缴税操作，但未完成税款缴纳，可能会造成申报表无法更正和作废。如需要正和作废，请30分钟后操作，或通过 【
            <el-text type="primary">支付订单管理</el-text>
            】作废订单后在操作。
        </div>
        <div style="padding: 10px 0;">
            <el-button type="primary" @click="beginPay">立即缴纳</el-button>
        </div>
        <el-table ref="tableRef" :data="tableData" style="width: 100%" border>
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column prop="name" label="税款所属月份" >
                <template #default="{ row }">
                    <span>2026-01</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="报税类型" >
                <template #default="{ row }">
                    <span>综合所得申报</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="应补/退税额" >
                <template #default="{ row }">
                    <span>{{ TaxCreditPayable }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="欠税金额" >
                <template #default="{ row }">
                    <span>{{ TaxCreditPayable }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="滞纳金" >
                <template #default="{ row }">
                    <span>0.00</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="税款期限" >
                <template #default="{ row }">
                    <span>2026-01</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="收款国库" >
                <template #default="{ row }">
                    <span>国家金库</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="税款所属税务机关" >
                <template #default="{ row }">
                    <span>国家税务总局XXX市税务局</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="登记注册类型" >
                <template #default="{ row }">
                    <span>私营有限公司</span>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
            v-model="dialogVisible"
            title="税款缴纳"
            width="1000"
            @close="init"
        >
            <div class="pay_info" v-if="payStep == 1">
                <div class="tip">
                    <el-icon color="#409eff"><WarningFilled /></el-icon>
                    温馨提示：如果当前页面无法正常操作，您可以 【<el-text type="primary">复链接接</el-text>】 到浏览器地址栏粘贴后缴款(三方协议缴税需点击[立即支付] 后才能选择缴款账号)
                </div>
                <div class="wj">
                    自然人电子税务局
                </div>
                <div class="amount">
                    <div class="item">
                        <span style="color: #666;">待支付项目</span>
                        <span>《综合所得个人所得税预扣预缴申报》</span>
                    </div>
                    <div class="item">
                        <div class="num">
                            {{ TaxCreditPayable }}
                        </div>
                        <div>
                            <el-text >税款:{{ TaxCreditPayable }}</el-text>
                            <el-text > 滞纳金:0.00</el-text>
                        </div>
                    </div>
                </div>
                <div class="pay_away">
                    <el-radio-group v-model="payWay" size="large">
                        <el-radio-button border label="三方协议支付" value="1" >
                            <div class="pay_way_content">
                                <img :src="xieyi" alt="">
                                <span>三方协议支付</span>
                                <div class="p">如您已与汇缴地税机关和银行签订定三方协议，可根据协议自动扣款</div>
                                <div class="icon" :class="{active:payWay == '1'}">
                                    <svg aria-hidden="true" width="1em" height="1em">
                                        <use xlink:href="#icon-gou" fill="currentColor" />
                                    </svg>
                                    <!-- <el-icon size="20" :color="payWay == '1' ? '#409eff':''"><CircleCheckFilled /></el-icon> -->
                                </div>
                            </div>
                        </el-radio-button>
                        <el-radio-button border label="银联在线支付" value="2" >
                            <div class="pay_way_content">
                                <img :src="yinlian" alt="">
                                <span>银联在线支付</span>
                                <div class="p">请使用带有银联标识的银行卡支付</div>
                                <div class="icon" :class="{active:payWay == '2'}">
                                    <!-- <el-icon size="20" :color="payWay == '2' ? '#409eff':''"><CircleCheckFilled /></el-icon> -->
                                    <svg aria-hidden="true" width="1em" height="1em">
                                        <use xlink:href="#icon-gou" fill="currentColor" />
                                    </svg>
                                </div>
                            </div>
                        </el-radio-button>
                        <el-radio-button border label="银行柜台支付" value="3" >
                            <div class="pay_way_content">
                                <img :src="guitai" alt="">
                                <span>银行柜台支付</span>
                                <div class="p">自行打印“银行端查询缴款凭证”，前往银行柜台支付</div>
                                <div class="icon" :class="{active:payWay == '3'}">
                                    <svg aria-hidden="true" width="1em" height="1em">
                                        <use xlink:href="#icon-gou" fill="currentColor"  />
                                    </svg>
                                    <!-- <el-icon size="20" :color="payWay == '3' ? '#409eff':''"><CircleCheckFilled /></el-icon> -->
                                </div>
                            </div>
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <div class="dialog-footer">
                    <el-button type="primary" @click="payOne(2)">
                        立即支付
                    </el-button>
                </div>
            </div>
            <div class="pay_info" v-if="payStep == 2">
                <div class="tip">
                    <el-icon color="#409eff"><WarningFilled /></el-icon>
                    温馨提示：如果当前页面无法正常操作，您可以 【<el-text type="primary">复链接接</el-text>】 到浏览器地址栏粘贴后缴款(三方协议缴税需点击[立即支付] 后才能选择缴款账号)
                </div>
                <div class="wj">
                    自然人电子税务局
                </div>
                <p style="padding: 10px 0;">请确认待支付项目及第三方支付方式</p>
                <div style="background-color: #fdf6ec;padding: 8px 0;">
                    <el-icon color="#e6a23c"><WarningFilled /></el-icon>
                    若您在近期变更过三方协议信息，请点此 【<el-text type="primary"> 刷新</el-text>】
                </div>
                <div class="current_way_content">
                    <img :src="currentPayImg[payWay]" alt="">
                    <span>320501******0625</span>
                </div>
                <div class="dialog-footer">
                    <el-button type="primary" text @click="payOne(1)">重新选择支付方式</el-button>
                    <el-button type="primary" @click="payOne(3)">
                        立即支付
                    </el-button>
                </div>
            </div>
            <div class="pay_info" v-if="payStep == 3">
                <div class="tip">
                    <el-icon color="#409eff"><WarningFilled /></el-icon>
                    温馨提示：如果当前页面无法正常操作，您可以 【<el-text type="primary">复链接接</el-text>】 到浏览器地址栏粘贴后缴款(三方协议缴税需点击[立即支付] 后才能选择缴款账号)
                </div>
                <div class="wj">
                    自然人电子税务局
                </div>
                <div class="amount">
                    <div class="item">
                        <p>
                            <span style="color: #666;">支付项目</span>
                            <span style="color: #333;margin-left: 10px;">个人所得税</span>
                        </p>
                        <p>
                            <span style="color: #666;">电子税票号码</span>
                            <span style="color: #333;margin-left: 10px;">623091310881951679</span>
                        </p>
                    </div>
                    <div class="item">
                        <div class="num">
                            {{ TaxCreditPayable }}
                        </div>
                        <div>
                            <el-text >税款:{{ TaxCreditPayable }}</el-text>
                            <el-text > 滞纳金:0.00</el-text>
                        </div>
                    </div>
                </div>
                <el-result
                    icon="success"
                    title="缴税成功"
                >
                    <template #extra>
                        <div class="current_way_content">
                            <img :src="currentPayImg[payWay]" alt="">
                            <span>320501******0625</span>
                        </div>
                        <el-button type="primary" @click="dialogVisible=false">我知道了</el-button>
                    </template>
                </el-result>
            </div>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
.pay_over{
    width: 100%;
    height: 100%;
    .tip{
        display: flex;
        align-items: center;
        color:var(--el-text-color-regular);
        font-size: 14px;
    }
    .pay_info{
        .wj{
            background-color: var(--el-color-primary);
            padding: 8px;
            color:#fff;
            margin: 20px 0;
        }
        .dialog-footer{
            display: flex;
            justify-content: flex-end;
            padding: 16px 0;
        }
        .amount{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            .item{
                height: 50px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-around;
                .num{
                    font-size: 28px;
                    color:var(--el-color-warning);
                }

            }
        }
        .current_way_content{
            display: flex;
            align-items: center;
            border:1px solid #eee;
            margin: 20px 0;
            padding: 16px;
            box-sizing: border-box;
            min-width: 400px;
            img{
                display: block;
                width: 50px;
                height: 50px;
            }
            span{
                margin-left: 20px;
            }
        }
        :deep(.el-radio-group){
            display: flex;
            .el-radio-button {
                width: 100%;
                margin-top: 8px;
                .el-radio-button__inner{
                    width: 100%;
                    border: var(--el-border);
                    .pay_way_content{
                        width: 100%;
                        display: flex;
                        align-items: center;
                        position: relative;
                        img{
                            display: block;
                            width: 50px;
                            height: 50px;
                        }
                        .p{
                            color:#888 !important;
                            margin-left: 20px;
                        }
                        .icon{
                            color:#888;
                            position: absolute;
                            right: -18px;
                            bottom: -16px;
                            font-size: 30px;
                        }
                        .icon.active{
                            color:var(--el-color-primary);
                            // svg{
                            //     fill: var(--el-color-primary);
                            // }
                        }
                    }
                }
            }
            .el-radio-button.is-active .el-radio-button__original-radio:not(:disabled)+.el-radio-button__inner{
                background-color:#fff;
                color:#333;
                border-color:  var(--el-color-primary);;
            }
            .el-radio-button__inner:hover {
                color:#676666;
            }
        }
    }

}
</style>
